import { StyleSheet } from "@react-pdf/renderer";
import { blue, red, lightGray } from "./PDFColors";

export const styles = StyleSheet.create({
  red: {
    color: red,
  },

  backgroundBlue: {
    height: "100%",
    width: "100%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "10pt",
  },

  slideContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },

  companyResults: {
    height: "100%",
    width: "50%",
  },

  companyResultsContent: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },

  companyResultsLeft: {
    height: "100%",
    width: "90%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
  },

  companyResultsRight: {
    height: "100%",
    width: "10%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
  },

  companyResultTopTitle: {
    height: "8%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  companyResultBottomScheme: {
    height: "92%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },

  sharesResults: {
    height: "100%",
    width: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    padding: "10px",
  },

  companyNameBox: {
    height: "20%",
    width: "75%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "2pt",
    borderRadius: "15px",
    justifyContent: "center",
    textAlign: "center",
  },

  schemeBottomContainer: {
    height: "40%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },

  schemeTopContainer: {
    height: "40%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-end",
  },

  schemeLine: {
    width: "2px",
    backgroundColor: blue,
    height: "80px",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-end",
  },

  schemeLineLong: {
    width: "2px",
    backgroundColor: blue,
    height: "180px",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-end",
  },

  founderBoxTop: {
    width: "20%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
  },

  founderBoxBottom: {
    width: "20%",
    height: "100%",
    alignItems: "center",
  },

  founderSharesBox: {
    width: "80px",
    height: "65px",
    display: "flex",
    flexDirection: "row",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
    borderRadius: "5px",
  },

  founderSharesBoxLeft: {
    width: "50%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },

  personIcon: {
    height: "30px",
  },

  companyIcon: {
    height: "30px",
    borderStyle: "solid",
    borderWidth: "1pt",
    borderBottomLeftRadius: "25% 100%",
    borderBottomRightRadius: "25% 100%",
    borderTopLeftRadius: "25% 100%",
    borderTopRightRadius: "25% 100%",
    borderColor: blue,
  },

  founderSharesBoxRight: {
    width: "50%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: "auto",
  },

  founderNameContainerTop: {
    width: "98%",
    height: "100%",
    alignItems: "center",
    justifyContent: "flex-end",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
  },

  founderNameContainerBottom: {
    width: "98%",
    height: "100%",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
  },

  textShares: {
    fontSize: "11px",
    width: "40px",
  },

  textTitle: { fontSize: "15px", color: blue },

  textFounderName: { fontSize: "12px", textAlign: "center" },

  textSideNoteTextBox: {
    textAlign: "justify",
    fontSize: "9px",
  },

  sideNoteTextBox: {
    width: "390px",
    height: "45px",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
    padding: "4px",
    justifyContent: "center",
    backgroundColor: lightGray,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "4px",
  },

  pieChart: {
    width: "390px",
    height: "410px",
    margin: "auto",
  },
});
